import { useMemo } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { useGetTabList } from '~hooks/queries/vessels/data/use-get-tab-list'
import { useGetGeneralInfo } from '~hooks/queries/vessels/use-get-general-info'

export function useConstructSubPages() {
  const { vessel } = useParams()
  const {
    data: generalInfo,
    isLoading: isGeneralInfoLoading,
    isError: isGeneralInfoError,
  } = useGetGeneralInfo({ vessel })
  const [searchParams] = useSearchParams()
  const vesselId = searchParams.get('vesselId')

  const {
    data: tabs,
    isLoading: isTabsLoading,
    isError: isTabsError,
  } = useGetTabList({
    vesselId: vesselId || generalInfo?.vesselId || null,
    type: 'financials',
  })

  const subPages = useMemo(
    () =>
      tabs?.flatMap((tab) => {
        return vessel
          ? [
              {
                title: tab.name,
                link: `/financials/vessels/${vessel}/${tab.path}`,
              },
            ]
          : []
      }) ?? [],
    [tabs, vessel],
  )

  return {
    subPages,
    isLoading: isGeneralInfoLoading || isTabsLoading,
    isError: isGeneralInfoError || isTabsError,
  }
}
